import React from 'react';
import styles from './content.module.scss';
import {Form, FormControl, FormLabel, Row} from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from "@/app/axios";
import {useDispatch} from "react-redux";
import {ALERT} from "@/actions/types";
import {loaded, loading} from "@/actions/loader";
import { isMobileApp } from '@/app/general';

const ContactContent: React.FC<any> = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const dispatch = useDispatch();

    const contactInfo = {
        number: '+989382666208',
        email: 'info@textnevis.ir'
    };

    const onSubmit = (data: object) => {
        loading()(dispatch);
        axios.post(`api/contact`, data).then((res) => {
            dispatch({
                type: ALERT,
                payload: { message: res.data }
            });
            loaded()(dispatch);
        }).catch((err) => {
            dispatch({
                type: ALERT,
                payload: { message: err.response.data || { result: 0, message: 'خطای نامشخص' } }
            });
            loaded()(dispatch);
        });
    };

    return (
        <div className={styles.contact}>
            <div className={styles.title}>
                <h2>
                    <i className="fa fa-envelope" />
                    تماس با پشتیبانی تکست نویس
                </h2>
            </div>
            <div className={styles.body}>
                <Row>
                    <div className="col-lg-8 col-md-6 mb-4">
                        <div className={styles.form}>
                            <div className={styles.title}>
                                <h4>{ '> ' }ارسال پیام از طریق { isMobileApp() ? " اپلیکیشن" : " وبسایت" }</h4>
                            </div>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <div className="col-lg-4">
                                        <div className="mb-3">
                                            <FormLabel htmlFor="full_name">نام کامل *</FormLabel>
                                            <FormControl id="full_name" {...register('full_name', {
                                                required: {
                                                    message: "ورود نام الزامیست!",
                                                    value: true
                                                }
                                            })} />
                                            {errors.full_name && <p className="text-danger">{errors.full_name.message as string}</p>}
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="mb-3">
                                            <FormLabel htmlFor="email">ایمیل *</FormLabel>
                                            <FormControl id="email" {...register('email', {
                                                required: {
                                                    message: "ورود ایمیل الزامیست!",
                                                    value: true
                                                },
                                                pattern: {
                                                    message: "ایمیل بدرستی وارد نشده است",
                                                    value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                }
                                            })} />
                                            {errors.email && <p className="text-danger">{errors.email.message as string}</p>}
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="mb-3">
                                            <FormLabel htmlFor="phone_number">شماره تماس</FormLabel>
                                            <FormControl id="phone_number" {...register('phone_number')} />
                                        </div>
                                    </div>
                                    <div className="container-fluid">
                                        <div className="mb-3">
                                            <FormLabel htmlFor="message">متن پیام *</FormLabel>
                                            <textarea className="form-control" id="message" {...register('message', {
                                                required: {
                                                    message: "ورود متن پیام الزامیست!",
                                                    value: true
                                                },
                                            })} />
                                            {errors.message && <p className="text-danger">{errors.message.message as string}</p>}
                                        </div>
                                    </div>
                                    <div className="container-fluid">
                                        <input type="submit" value="ارسال پیام" className="btn btn-primary" />
                                    </div>
                                </Row>
                            </Form>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className={styles.info}>
                            <div className={styles.infoTitle}>
                                <h4>
                                    {'> '}
                                    دیگر گزینه های تماس
                                </h4>
                            </div>
                            <div className={styles.infoItem}>
                                <strong><i className="fa fa-phone" /> شماره همراه</strong>
                                <a className="light-anchor" href={"tel:" + contactInfo.number}>{contactInfo.number}</a>
                            </div>
                            <div className={styles.infoItem}>
                                <strong><i className="fa fa-envelope" /> ایمیل</strong>
                                <a className="light-anchor" href={"mailto:" + contactInfo.email}>{contactInfo.email}</a>
                            </div>
                        </div>
                    </div>
                </Row>
            </div>
        </div>
    );
}

export default ContactContent;
